import script from "./TableFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./TableFooter.vue?vue&type=script&setup=true&lang=js"

import "./TableFooter.vue?vue&type=style&index=0&id=2801203f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2801203f"]])

export default __exports__